// extracted by mini-css-extract-plugin
export default {"item":"ItemsList_item__LNYf+","description":"ItemsList_description__DqH1z","price":"ItemsList_price__e4ra8"};